/**
 * 地图坐标与初始缩放统一工具。
 *
 * 设备上报坐标统一为 WGS84。不同底图坐标系不同，必须按厂商转换才能让同一物理位置
 * 在两张图上目视落在同一地点：
 *   - 天地图底图 = CGCS2000 ≈ WGS84，直接用。
 *   - 谷歌国内瓦片 = GCJ-02（国测局偏移坐标系），必须 WGS84→GCJ02 才能落在正确路面。
 *   - 谷歌海外瓦片 = WGS84，不转。
 *
 * 初始缩放按场景给固定值，保证切换天地图/谷歌时看到同样范围；
 * 多点场景由调用方用 fitBounds/密度算法决定，两边用同一套，不在此写死。
 */
const coordtransform = require('coordtransform')

// 中国大陆经纬度粗判边界。海外点一定不进此框；边界附近误差可接受。
function isInChina (lng, lat) {
  return lng >= 72.004 && lng <= 137.8347 && lat >= 0.8293 && lat <= 55.8271
}

/**
 * 把 WGS84 坐标按底图厂商转成该底图应使用的坐标系。
 * @param {number} lng WGS84 经度
 * @param {number} lat WGS84 纬度
 * @param {'tianditu'|'google'} vendor 底图厂商
 * @returns {{lng:number,lat:number}|null} 非法或 (0,0) 返回 null
 */
function toMapLngLat (lng, lat, vendor) {
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null
  if (lng === 0 && lat === 0) return null
  if (vendor === 'google' && isInChina(lng, lat)) {
    const gcj = coordtransform.wgs84togcj02(lng, lat)
    return { lng: Number(gcj[0]), lat: Number(gcj[1]) }
  }
  return { lng, lat }
}

/**
 * 按场景给初始缩放，保证天地图与谷歌看到同样范围。
 * @param {number} pointCount 点位数
 * @returns {number|null} 无数据 5；单点 18；多点 null（交给调用方 fitBounds）
 */
function resolveInitialZoom (pointCount) {
  if (!pointCount || pointCount <= 0) return 5
  if (pointCount === 1) return 18
  return null
}

module.exports = {
  isInChina,
  toMapLngLat,
  resolveInitialZoom
}
